(ns dre.components.searchbar.util
  "Utility functions to be used in event and subscription handlers for searchbar."
  (:require
   [clojure.set :as set]
   [clojure.string :as str]
   [dre.pages.my-searches.tags.events :as utag-events]
   [dre.pages.my-searches.signals.events :as signal-events]
   [dre.components.searchbar.suggestion-util :refer [author-suggestions->pills
                                                     new-suggestions
                                                     suggestions->pills]]
   [re-frame.core :as rf]))

;; TODO: move to a better ns
(defn has-keys?
  "Does the hashmap contains at least the given keys?"
  [x keyset]
  (set/superset? (-> x keys set) keyset))

;; TODO: move to a better ns
(defn pop-or-identity
  "If the given coll has items execute pop fn if not return same coll."
  [coll]
  (if (seq coll)
    (pop coll)
    coll))

(defn suggest-authors?
  "Are we going to suggest authors? If the input starts-with `author ` we only
   suggest authors."
  [input]
  (str/starts-with? input "author "))

(defn ->suggestions-query
  "Determines the query to be passed to suggestions API."
  [input]
  (if (suggest-authors? input)
    (str/replace input #"^author " "")
    input))

(defn ->suggestions-endpoint
  "Determines the endpoint to be used for fetching suggestions API."
  [input]
  (if (suggest-authors? input)
    :dictionary/author-suggestions
    :dictionary/suggestions))

(defn ->suggestion-pills
  "Generates pills from suggestions response from API."
  [{:keys [input data]}]
  (let [->pills (if (suggest-authors? input)
                  author-suggestions->pills
                  suggestions->pills)]
    (->pills data)))

(defn ->suggestions
  "Generate suggestions to be showed in `dre.components.searchbar.suggestion-dropdown`."
  [{:keys [input caret-position search-query] :as opts}]
  ; TODO mode nil
  (new-suggestions #_input input
                   #_idx caret-position
                   #_mode nil
                   #_pills (-> search-query :query/pills (or []))
                   #_dict-pills (->suggestion-pills opts)
                   #_signals @(rf/subscribe [::signal-events/signals-without-filter]) ; TODO
                   #_tags @(rf/subscribe [::utag-events/tags-without-filter]))) ; TODO
